import { CLEAR_STORE, GET_USER_ADDRESS, SUBMIT_SCHEDULE_INTERVIEW } from '../../action-contants';

const INITIAL_STATE = {
  interviewAddr: {},
  scheduledInterviewDetails: {}
};

export default function scheduleInterviewReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }
    case GET_USER_ADDRESS: {
      return { ...state, interviewAddr: action.data };
    }
    case SUBMIT_SCHEDULE_INTERVIEW: {
      return { ...state, scheduledInterviewDetails: action.data };
    }
    default:
      return state;
  }
}
